export default {
  '--app-primary-color': 'hsl(345, 80%, 35%)', // Rojo corporativo (fuerza, liderazgo)
  '--app-secondary-color': 'hsl(345, 70%, 55%)', // Rojo más claro para hover/acciones
  '--app-tertiary-color': 'hsl(0, 0%, 96%)', // Fondo neutro claro

  '--app-accent-color': 'hsl(0, 0%, 55%)', // Gris medio (equilibrio visual)
  '--app-accent-light': 'hsl(0, 0%, 85%)', // Gris claro (fondos secundarios)

  '--app-disabled-color': 'hsl(0, 0%, 80%)',

  '--sidebar-bg-color': 'hsl(0, 0%, 98%)',
  '--sidebar-icon-color': 'hsl(345, 80%, 35%)',
  '--sidebar-text-color': 'hsl(0, 0%, 25%)',

  '--sidebar-active-bg-color': 'hsl(345, 80%, 35%)',
  '--sidebar-active-text-color': 'hsl(0, 0%, 100%)'
};
